import { IconButton, useToaster, Message } from 'rsuite';
import CopyIcon from '@rsuite/icons/Copy';

function CopyButton({ 
  text, 
  disabled = false, 
  appearance = 'subtle',
  size = 'sm',
  successMessage = 'Copied to clipboard',
  errorMessage = 'Failed to copy to clipboard',
  title = 'Copy to clipboard',
  ...props 
}) {
  const toaster = useToaster();

  const handleCopy = async () => {
    if (!text || text.trim().length === 0) {
      toaster.push(
        <Message type="error" showIcon>
          No content to copy
        </Message>,
        { placement: 'bottomCenter', duration: 3000 }
      );
      return;
    }

    try {
      await navigator.clipboard.writeText(text.trim());
      toaster.push(
        <Message type="success" showIcon>
          {successMessage}
        </Message>,
        { placement: 'bottomCenter', duration: 3000 }
      );
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
      toaster.push(
        <Message type="error" showIcon>
          {errorMessage}
        </Message>,
        { placement: 'bottomCenter', duration: 3000 }
      );
    }
  };

  return (
    <IconButton
      appearance={appearance}
      size={size}
      icon={<CopyIcon />}
      onClick={handleCopy}
      disabled={disabled || !text || text.trim().length === 0}
      title={title}
      {...props}
    />
  );
}

export default CopyButton;

